/* eslint-disable prettier/prettier */
<template>
  <div>
    <v-row>
      <v-col cols="4" v-for="(item, i) in form" :key="i">
        <v-text-field
          :label="item.label"
          v-model="item.value"
          outlined
          :rules="item.rules"
          dense
          :type="item.type"
          :disabled="item.disabled"
          :max="item.counter"
          :counter="item.counter"
          @input="input"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card outlined>
      <v-card-text class="mb-0 pb-0">
        <v-form v-model="isValid" ref="form">
          <v-row>
            <v-col cols="12" sm="2" class="py-0">
              <v-autocomplete
                label="Year From"
                outlined
                dense
                :rules="field"
                v-model.trim="model.from"
                :items="years"
                type="number"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" class="py-0">
              <v-autocomplete
                label="Year To"
                outlined
                v-model.trim="model.to"
                dense
                :rules="yearTo"
                :items="years"
                type="number"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="8"
              class="d-flex py-0"
              :class="$root.isMobile ? 'flex-column' : ''"
            >
              <v-text-field
                v-model.trim="model.name"
                :rules="rules"
                label="Type model name and hit Add Model button"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="4"
              sm="4"
              class="">
              <v-text-field
                v-model.trim="model.carUnlocking"
                :rules="[]"
                type="number"
                label="Car Unlocking"
                outlined
                dense
                prepend-inner-icon="mdi-currency-usd"
                @input="onLostCarKeyInput"
              >
              </v-text-field>
            </v-col>
            <v-col v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" cols="8" class="text-right ">
              <v-btn
                :class="$root.isMobile ? 'mb-4' : 'ml-4'"
                v-if="index == -1 && (isAdmin || isDataEntry || isDataEntryAndDispatcher)"
                outlined
                height="40px"
                tile
                @click="add()"
              >
                <v-icon left>mdi-plus</v-icon>
                Add Model</v-btn
              >
              <v-btn
                v-else-if="index  != -1 &&  (isAdmin || isDataEntry || isDataEntryAndDispatcher)"
                class="ml-4"
                outlined
                height="40px"
                @click="update()"
              >
                Update Model</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card outlined flat tile class="mt-5">
      <v-data-table
        :search="search"
        :headers="headers"
        class="templates-table"
        :items="list"
      >
        <template v-slot:top>
          <div class="pa-5 pb-0">
            <v-text-field
              label="Search Model"
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
            >
            </v-text-field>
          </div>
        </template>
        <template v-slot:item.action="{ item }"
          ><edit-icon-button
            @click="openEdit(item, item.index)"
          ></edit-icon-button>
          <v-btn v-if="isAdmin" icon @click="remove(item.index)" color="red">
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// import customerModal from "../../../assets/js/customer.modal";
import EditIconButton from "../../buttons/EditIconButton.vue";
const defaultForm = {
  name: "",
  from: "",
  to: "",
  carUnlocking: 0.00,
};
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    EditIconButton,
  },
  data() {
    return {
      models: [],
      search: "",
      name: "",
      isValid: false,
      index: -1,
      model: {
        ...defaultForm,
      },
      rules: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 255 || "Field must be less than 255 characters",
      ],
      field: [(v) => !!v || "Field is required"],
      yearTo: [
        (v) => !!v || "Field is required",
        (v) => this.model.from <= v || "Field must be more than from year",
      ],
    };
  },
  computed: {
    list() {
      return [...this.models].map((i, index) => ({
        ...i,
        index,
      }));
    },
    years() {
      let year = 1959;
      let list = [];
      while (year < new Date().getFullYear()) {
        year++;
        list.push(year);
      }
      return list.reverse();
    },
    isUpdate() {
      return this.$route.name === "car-make-unlocking-update";
    },
    headers() {
      let headers = [
        { text: "Year From", value: "from" },
        { text: "Year To", value: "to" },
        { text: "Model", value: "name" },
        { text: "ACTION", value: "action" },
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text: text.toUpperCase(),
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true,
        };
        if (value === "action") {
          doc.divider = false;
          doc.width = "150px";
        }
        list.push(doc);
      }
      return list;
    },
    form: {
      get() {
        let { name, make_id } = this.value;
        if (name === undefined) name = "";
        if (make_id === undefined) make_id = "";
        let form = [
          {
            value: make_id,
            key: "make_id",
            label: "ID",
            rules: this.rules,
            disabled: false,
            type: "number",
            counter: "",
          },
          {
            value: name,
            key: "name",
            label: "Make",
            rules: this.rules,
            disabled: false,
            type: "text",
            counter: 255,
          },
        ];
        return form;
      },
    },
  },
  methods: {
    onLostCarKeyInput(value) {
      this.model.carUnlocking = value ? Number(value) : 0.00;
    },
    openEdit(item, index) {
      const vm = this;
      let doc = {};
      Object.keys(item).forEach((key) => {
        doc[key] = item[key];
      });
      vm.model = doc;
      vm.index = index;
    },
    isExists(model) {
      let keys = Object.keys(defaultForm);
      return this.models.findIndex((i) => {
        let results = keys.filter((key) => {
          return (
            model[key] &&
            i[key] &&
            model[key].toString().trim() == i[key].toString().trim()
          );
        });
        return results.length == keys.length;
      });
    },
    add() {
      let vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      console.log(vm.isExists(vm.model));
      if (vm.isExists(vm.model) != -1) {
        vm.$root.alert("Model already exits");
        return;
      }
      let doc = {};
      Object.keys(vm.model).forEach((key) => {
        doc[key] = vm.model[key];
      });
      vm.models.unshift(doc);
      vm.$refs.form.reset();
      vm.model = {
        ...defaultForm,
      };
      vm.input();
    },
    update() {
      let vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let index = vm.isExists(vm.model);
      if (index != -1 && index != vm.index) {
        vm.$root.alert("Model already exits");
        return;
      }
      let doc = {};
      Object.keys(vm.model).forEach((key) => {
        doc[key] = vm.model[key] || "";
      });
      console.log('unlcokingdoc---------->',doc);
      vm.$set(vm.models, vm.index, doc);
      vm.index = -1;
      vm.$refs.form.reset();
      vm.model = {
        ...defaultForm,
      };
      vm.input();
    },
    remove(index) {
      let vm = this;
      vm.$confirm.show({
        message: "Are you sure?",
        onConfirm: () => {
          vm.models.splice(index, 1);
          vm.input();
          vm.index = -1;
          vm.model = {
            name: "",
            from: "",
            to: "",
            carUnlocking: 0.00,
          };
        },
      });
    },
    input() {
      let form = {};
      const vm = this;
      vm.form.forEach(({ key, value }) => {
        form[key] = value;
      });
      form.models = vm.models;
      console.log('form---->',form);
      
      vm.$emit("input", form);
    },
  },
  mounted() {
    this.models = this.value.models;
    console.log(this.value.models);
    console.log(this);
    
  }
};
</script>

<style></style>
